export { default as PageTab } from './PageTab.vue'
export { default as PageTabGroup } from './PageTabGroup.vue'
export { default as PageTabList } from './PageTabList.vue'
export { default as PageTabPanel } from './PageTabPanel.vue'
export { default as PageTabPanels } from './PageTabPanels.vue'

export const createPageTabs = ({ TABS = {}, isVisible }) => {
  const pageTabs = {}

  for (const tab of Object.values(TABS)) {
    pageTabs[tab] = {
      label: tab,
      flagged: false,
      flaggedCount: 0,
      visible: typeof isVisible === 'function' ? isVisible(tab) : true
    }
  }
  return pageTabs
}

export const addFlagsToPageTabs = ({ pageTabs = {}, flags = [], FLAG_TAB_MAP = {} }) => {
  flags.forEach((flag) => {
    if (FLAG_TAB_MAP[flag] && pageTabs[FLAG_TAB_MAP[flag]]) {
      pageTabs[FLAG_TAB_MAP[flag]].flagged = true
      pageTabs[FLAG_TAB_MAP[flag]].flaggedCount++
    }
  })
}

export const shouldShowFlaggedCount = (flags = []) => {
  return {
    showFlaggedCount: flags.length > 1
  }
}
